import React from 'react';
import orgConfig from 'org/configs/org.config';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { InstoreLoginLink, Logo, Disclaimer } from 'core/modules/Instore2/partials';

import { InstoreOfferModalTitle, InstoreOnlyPill } from '../partials';

import '../InstoreOfferDetails.scss';

const { instoreLabel } = orgConfig;

function AnonymousView({ offer, isModal }) {
  const {
    displayRate, currency, rclonMerchantName, disclaimer,
  } = offer;

  return (
    <div className="mn_instoreOfferDetails mn_anonymousView">
      {!isModal && <InstoreOnlyPill />}
      {!isModal && <Logo offer={offer} />}
      <InstoreOfferModalTitle offer={offer} />
      <div id="mn_dialogDescription" className="mn_offerInfo">
        Earn {displayRate} {currency} {instoreLabel} at {rclonMerchantName}<span className="mn_dot">.</span>
      </div>
      <InstoreLoginLink className="mn_button">Sign in to get the offer</InstoreLoginLink>
      <Disclaimer>{disclaimer}</Disclaimer>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><AnonymousView {...props} /></ComponentErrorBoundary>;
